/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Grid, Typography } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import AppointMentBoolInput from "../../../components/AppointMentBoolInput/AppointMentBoolInput";
import Button from "../../../components/common/Button";
import Modal from "../../../components/common/Modal/Modal";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import {
  APPOINTMENT_CYCLE_FIELDS,
  EXAMINATION_CYCLE_FIELD,
} from "../../../contants/formFields";
import Announcement from "../../../services/api/announcement";
import { debounce } from "../../../utils/helper";
import { examinationLevel, moduleName, structureLevel } from "../helper";
import { formStyles } from "./ViewAnnouncement.Style";
import { checkFormValues } from "../CreateAnnouncement/CreateAppointmentCycle";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";

function UpdateAnnouncementModalForm({
  values,
  setFieldValue,
  handleChange,
  currentModalType,
}) {
  const readOnly = currentModalType !== "edit";

  const [minEndDate, setMinEndDate] = useState(null);
  return (
    <>
      <div
        style={{
          paddingRight: "66%",
          paddingBottom: "12px",
          marginTop: "-20px",
        }}
      >
        <AppointMentBoolInput
          name={APPOINTMENT_CYCLE_FIELDS.ACTIVE}
          value={values[APPOINTMENT_CYCLE_FIELDS.ACTIVE]}
          preLabel="Active"
          handleChange={handleChange}
          required
          readOnly={readOnly}
        />
      </div>
      <div style={formStyles.gridContainer}>
        <div style={formStyles.gridItem}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.displayName}
            name={APPOINTMENT_CYCLE_FIELDS.MODULE}
            label="Module Type"
            options={moduleName}
            value={values?.[APPOINTMENT_CYCLE_FIELDS.MODULE]}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(APPOINTMENT_CYCLE_FIELDS.MODULE, "");
              } else {
                setFieldValue(
                  APPOINTMENT_CYCLE_FIELDS.MODULE,
                  selectedValue.value
                );
              }
            }}
            style={{ fontSize: "14px" }}
            inputProps={{
              required: true,
              placeholder: "Select Module Type",
            }}
            disabled
          />
        </div>
        <div style={formStyles.gridItem}>
          {values?.[APPOINTMENT_CYCLE_FIELDS.MODULE] === "APPOINTMENT" ? (
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.displayName}
              name={APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL}
              label="Structure Level"
              options={structureLevel}
              value={values?.[APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL]}
              onChange={(selectedValue) => {
                if (selectedValue) {
                  setFieldValue(
                    APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL,
                    selectedValue.value
                  );
                }
              }}
              style={{ fontSize: "14px" }}
              inputProps={{
                required: true,
                placeholder: "Select Structure Level",
              }}
              disabled
            />
          ) : (
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.displayName}
              name={EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL}
              label="Examination Level"
              options={examinationLevel}
              value={values?.[EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL]}
              onChange={(selectedValue) => {
                if (selectedValue) {
                  setFieldValue(
                    EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL,
                    selectedValue.value
                  );
                }
              }}
              style={{ fontSize: "14px" }}
              inputProps={{
                required: true,
                placeholder: "Select Examination Level",
              }}
              disabled
            />
          )}
        </div>
        <div style={formStyles.gridItem}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              name={APPOINTMENT_CYCLE_FIELDS.START_DATE}
              label="Start Date"
              inputFormat="DD/MM/YYYY"
              minDate={new Date()}
              value={values?.[APPOINTMENT_CYCLE_FIELDS.START_DATE]}
              onChange={(newValues) => {
                setFieldValue(
                  [APPOINTMENT_CYCLE_FIELDS.START_DATE],
                  dayjs(newValues).format("YYYY-MM-DD")
                );
                setMinEndDate(
                  new Date(new Date(newValues).getTime() + 24 * 60 * 60 * 1000)
                );
              }}
              renderInput={(params) => <InputField {...params} />}
              disabled={readOnly}
            />
          </LocalizationProvider>
        </div>
        <div style={formStyles.gridItem}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              name={APPOINTMENT_CYCLE_FIELDS.END_DATE}
              label="End Date"
              inputFormat="DD/MM/YYYY"
              minDate={minEndDate}
              value={values?.[APPOINTMENT_CYCLE_FIELDS.END_DATE]}
              onChange={(newValues) =>
                setFieldValue(
                  [APPOINTMENT_CYCLE_FIELDS.END_DATE],
                  dayjs(newValues).format("YYYY-MM-DD")
                )
              }
              renderInput={(params) => <InputField {...params} />}
              disabled={readOnly}
            />
          </LocalizationProvider>
        </div>
        {values?.[APPOINTMENT_CYCLE_FIELDS.MODULE] === "EXAMINATION" && (
          <div style={formStyles.gridItem}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                name={EXAMINATION_CYCLE_FIELD.EXAM_DATE}
                label="Exam Date"
                inputFormat="DD/MM/YYYY"
                // minDate={minEndDate}
                value={values?.[EXAMINATION_CYCLE_FIELD.EXAM_DATE]}
                onChange={(newValues) =>
                  setFieldValue(
                    [EXAMINATION_CYCLE_FIELD.EXAM_DATE],
                    dayjs(newValues).format("YYYY-MM-DD")
                  )
                }
                renderInput={(params) => <InputField {...params} />}
                disabled={readOnly}
              />
            </LocalizationProvider>
          </div>
        )}
        <div style={formStyles.gridItem}>
          <InputField
            label="Created By"
            // containerStyle={Styles.inputContainer}
            name={APPOINTMENT_CYCLE_FIELDS.CREATED_BY_NAME}
            value={values?.[APPOINTMENT_CYCLE_FIELDS.CREATED_BY_NAME]}
            disabled
          />
        </div>
      </div>
    </>
  );
}

function UpdateAnnouncementModal({
  open,
  onClose,
  selectedRow,
  setShowToast,
  currentModalType,
  readOnly,
  refresh,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);

  const getTitle = () => {
    if (currentModalType === "view") {
      return "View Announcement Cycle";
    }
    return "Update Announcement Cycle";
  };

  const postData = async (values) => {
    console.log("values :", values.active === "YES");
    console.log("id :", selectedRow?.id);

    try {
      setIsLoading(true);
      await Announcement.updateAnnouncement(
        {
          ...values,
          active: values.active === "YES",
        },
        selectedRow?.id
      );
      onClose();
      refresh();
      setShowToast({
        message: "Updated successfully",
        severity: "success",
      });
      setIsLoading(false);
    } catch (err) {
      Sentry.captureException(err);
      setShowToast({ message: err.message, severity: "error" });
      setIsLoading(false);
    }
  };

  useEffect(() => {}, [selectedRow]);

  return (
    <Modal open={open} onClose={onClose}>
      <Grid container>
        <Formik
          initialValues={{
            [APPOINTMENT_CYCLE_FIELDS.STRUCTURE_LEVEL]:
              selectedRow?.structureLevel,
            [APPOINTMENT_CYCLE_FIELDS.MODULE]: selectedRow?.module,
            [APPOINTMENT_CYCLE_FIELDS.START_DATE]: selectedRow?.startDate,
            [APPOINTMENT_CYCLE_FIELDS.END_DATE]: selectedRow?.endDate,
            [APPOINTMENT_CYCLE_FIELDS.ACTIVE]: selectedRow?.active
              ? "YES"
              : "NO",
            [APPOINTMENT_CYCLE_FIELDS.CREATED_BY_NAME]:
              selectedRow?.createdByName,
            [APPOINTMENT_CYCLE_FIELDS.CREATED_AT]: selectedRow?.createdAt,
            [EXAMINATION_CYCLE_FIELD.EXAMINATION_LEVEL]: selectedRow?.examLevel,
            [EXAMINATION_CYCLE_FIELD.EXAM_DATE]: selectedRow?.examDate,
          }}
          onSubmit={debounce((values) => {
            const error = checkFormValues(values);
            if (error) {
              toast.show(error, AlertStatus.ERROR);
              return;
            }
            postData(values, values.active === "YES");
          })}
        >
          {({ values, errors, handleChange, setFieldValue, handleSubmit }) => (
            <Grid>
              <div
                style={{
                  padding: "0px 0px 10px 10px",
                  color: "#8C8C8C",
                  marginTop: "-10px",
                }}
              >
                <Typography fontWeight="500" fontSize="20px">
                  {getTitle()}
                </Typography>
              </div>
              <div style={{ paddingTop: 20 }}>
                <UpdateAnnouncementModalForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  readOnly={readOnly}
                  currentModalType={currentModalType}
                />
              </div>
              {currentModalType !== "view" && (
                <Grid item mt={10}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    isLoading={isLoading}
                    label="Submit"
                    type="submit"
                  />
                  <Button
                    style={{ marginLeft: "1rem" }}
                    variant="outlined"
                    onClick={onClose}
                    label="Cancel"
                  />
                </Grid>
              )}
            </Grid>
          )}
        </Formik>
      </Grid>
    </Modal>
  );
}

export default UpdateAnnouncementModal;
